module.exports = __webpack_public_path__ + "img/s4-4.4bdec4aa.jpg";